<ng-container [ngSwitch]="invoiceType">
  <span class="badge badge-primary" *ngSwitchCase="'C'">Crédit</span>
  <span class="badge badge-warning" *ngSwitchCase="'F'">Facture</span>
  <span class="badge badge-secondary" *ngSwitchCase="'B'">Bon de livraison</span>
</ng-container>